export const orgChurnDetailsQuery = `
query OrgChurnDetails($orgId: ID!) {
  org_churn_indicators(
    first: 10,
    where: { org_pointer: { have: { objectId: { equalTo: $orgId } } } },
    order: [updatedAt_DESC]
  ) {
    edges {
      node {
        objectId
        status
        churn_risk
        eligible
        eligibility_reason
        last_login_at
        last_defunto_created_at
        last_service_reservation_created_at
        last_pet_created_at
        last_activity_created_at
        last_activity_class
        login_inactivity_days
        creation_inactivity_days
        days_since_last_login
        days_since_last_activity_creation
        login_inactive
        creation_inactive
        config_source
        computed_at
        days_since_last_editor_canvas_activity
        editor_canvas_existing_project_activity
        last_editor_canvas_activity_at
        last_editor_canvas_activity_project_age_days
        last_editor_canvas_activity_project_created_at
        last_editor_canvas_activity_type
        last_editor_canvas_created_at
        last_editor_canvas_page_updated_at
        last_editor_canvas_updated_at
        updatedAt
      }
    }
  }
  org_churn_configs(
    first: 20,
    where: {
      OR: [
        { scope: { equalTo: "global" }, config_key: { equalTo: "global" } },
        { scope: { equalTo: "org" }, org_pointer: { have: { objectId: { equalTo: $orgId } } } }
      ]
    },
    order: [updatedAt_DESC]
  ) {
    edges {
      node {
        objectId
        scope
        config_key
        enabled
        login_inactivity_days
        creation_inactivity_days
        updatedAt
        org_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export const createOrgChurnConfigMutation = `
mutation CreateOrgChurnConfig($fields: CreateOrg_churn_configFieldsInput) {
  createOrg_churn_config(input: { fields: $fields }) {
    org_churn_config {
      objectId
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export const updateOrgChurnConfigMutation = `
mutation UpdateOrgChurnConfig($id: ID!, $fields: UpdateOrg_churn_configFieldsInput) {
  updateOrg_churn_config(input: { id: $id, fields: $fields }) {
    org_churn_config {
      objectId
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export const deleteOrgChurnConfigMutation = `
mutation DeleteOrgChurnConfig($id: ID!) {
  deleteOrg_churn_config(input: { id: $id }) {
    org_churn_config {
      objectId
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");
